export default __webpack_public_path__ + "assets/static/data/code-gen-data.2b5986d260234ad5ccd8f86b32e76606.json";